module.exports = __webpack_public_path__ + "img/Oxygen sensor.742c5451.jpg";